import { useBaseHook } from './useBaseHook'

export const useUpdate = (API) => {

    const { onApply } = useBaseHook(API)

    const onUpdate = (id, reqbody = {}) => onApply("post-operation", { id, ...reqbody })

    return { onUpdate }
}
